/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { bannerStyles } from "./styles"

/**
- Standard Banner component
**/
export const Banner = (props) => {
  const { type } = props
  return <section css={bannerStyles(type)}>{props.children}</section>
}

Banner.propTypes = {
  type: PropTypes.oneOf(["primary", "secondary"]),
  children: PropTypes.node.isRequired,
}

Banner.defaultProps = {
  type: "primary",
}
